import React, { FC, useCallback, useMemo } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { isSupplierInventoryConfigEnabled } from '../common/SupplierInventoryConfigPermissionChecker';
import { CONFIG_NAMES } from '../../utils/AuthUtils';

const { Content } = Layout;

const DepreciationOverviewPage: FC<any> = ({
	history,
	companyConfig,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/supplier/depreciation/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const exchangeRateEnabled = useMemo(
		() =>
			isSupplierInventoryConfigEnabled(
				companyConfig,
				CONFIG_NAMES.ALLOW_MONTHLY_CURRENCY_EXCHANGE_RATE
			),
		[companyConfig]
	);

	const tabs = useMemo(
		() => [
			{
				key: 'depreciationClass',
				name: 'Depreciation Classes',
			},
			{
				key: 'impairment',
				name: 'Impairments',
			},
			{
				key: 'burdenRates',
				name: 'Burden Rates',
			},
			{
				key: 'journalRuns',
				name: 'Journal Runs',
			},
			...(exchangeRateEnabled
				? [
						{
							key: 'exchangeRates',
							name: 'Exchange Rates',
						},
				  ]
				: []),
		],
		[exchangeRateEnabled]
	);

	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Route
					path="/supplier/depreciation/overview"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/supplier/depreciation/overview/depreciationClass',
							}}
						/>
					)}
				/>
				<Content style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<h4
							style={{
								color: 'rgba(255, 255, 255, 0.9)',
								marginRight: 8,
								marginBottom: 24,
							}}
						>
							Accounting
						</h4>
						<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
});

export default withRouter<any, any>(connect(mapStateToProps)(DepreciationOverviewPage));
